import { create } from 'zustand';

import { ChangePaymentPlanTierSchema } from '@/types/schema';

type BillingPlanStore = {
  stripeClientSecret: string | null;
  setStripeClientSecret: (s: string | null) => void;
  // add card information to subscribe modal
  isSubscribeModalOpen: boolean;
  setIsSubscribeModalOpen: (open: boolean) => void;

  // plan to upgrade to
  targetPlanTier: ChangePaymentPlanTierSchema | undefined;
  setTargetPlanTier: (newPlan: ChangePaymentPlanTierSchema | undefined) => void;
  // welcome message we show as success state
  isWelcomeMessageModalOpen: boolean;
  setIsWelcomeMessageModalOpen: (open: boolean) => void;

  // subscribe modal states
  showMangeSpend: boolean;
  setShowManageSpend: (b: boolean) => void;
  showAddCard: boolean;
  setShowAddCard: (b: boolean) => void;
  showClaimGift: boolean;
  setShowClaimGift: (b: boolean) => void;
};

export const useBillingPlanStore = create<BillingPlanStore>((set) => {
  return {
    stripeClientSecret: null,
    setStripeClientSecret: (stripeClientSecret) =>
      set(() => ({ stripeClientSecret })),
    isSubscribeModalOpen: false,
    setIsSubscribeModalOpen: (isSubscribeModalOpen) =>
      set(() => ({ isSubscribeModalOpen })),
    targetPlanTier: undefined,
    setTargetPlanTier: (targetPlanTier) => set(() => ({ targetPlanTier })),
    isWelcomeMessageModalOpen: false,
    setIsWelcomeMessageModalOpen: (isWelcomeMessageModalOpen) =>
      set(() => ({ isWelcomeMessageModalOpen })),
    showMangeSpend: false,
    setShowManageSpend: (showMangeSpend) => set(() => ({ showMangeSpend })),
    showAddCard: false,
    setShowAddCard: (showAddCard) => set(() => ({ showAddCard })),
    showClaimGift: false,
    setShowClaimGift: (showClaimGift) => set(() => ({ showClaimGift })),
  };
});
